import React, { useEffect, useState } from "react";
import "./Create_Account_step1.css";
import { Form } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import "../../../common/common-css/CommonCss.css";
import Common_Btn from "../../../common/common-btn/Common_Btn";
import Form_Header from "../../../common/form-header/Form_Header";
import { getStates } from "../../../../utils/gymOwnerApi";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

const Create_Account_step1 = ({ step, totalSteps, formData, setStep, setFormData }) => {
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { control, handleSubmit, reset, register, watch, formState: { errors } } = useForm({
    defaultValues: {
      first_name: formData?.first_name || "",
      last_name: formData?.last_name || "",
      date_of_birth: formData?.dob ? new Date(formData.dob.split("/").reverse().join("-")).toISOString().split("T")[0] : "",
      mobile_number: formData?.mobile_number || "",
      email: formData?.email || "",
      address: formData?.address || "",
      password: formData?.password || "",
      re_password: formData?.re_password || "",
      state_id: formData?.state_id || "",

    },
  });

  console.log(

    { formData }
  );
  const password = watch("password");
  const [stateOptions, setStateOptions] = useState([]);
  const [statesLoading, setStatesLoading] = useState(true);

  const apiStates = async () => {
    const response = await getStates();
    if (response.success && response.data) {
      setStateOptions(response.data);
    }
    setStatesLoading(false);
  };

  useEffect(() => {
    apiStates();
  }, []);

  useEffect(() => {
    if (stateOptions.length > 0) {
      reset({
        first_name: formData?.first_name || "",
        last_name: formData?.last_name || "",
        date_of_birth: formData?.dob ? new Date(formData.dob.split("/").reverse().join("-")).toISOString().split("T")[0] : "",
        mobile_number: formData?.mobile_number || "",
        email: formData?.email || "",
        address: formData?.address || "",
        password: formData?.password || "",
        re_password: formData?.re_password || "",
        state_id: formData?.state_id || "",
      });
    }
  }, [stateOptions]);
  // Just validate and store data — API call happens at the last step
  const onSubmit = (data) => {
    const [year, month, day] = data.date_of_birth.split("-");
    const formattedDob = `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;

    setFormData((prev) => ({
      ...prev,
      first_name: data.first_name,
      last_name: data.last_name,
      mobile_number: data.mobile_number,
      email: data.email,
      address: data.address,
      password: data.password,
      re_password: data.re_password,
      state_id: data?.state_id || "",

      dob: formattedDob,   // ← e.g. "05/03/2000" instead of "2000-03-05"
    }));
    setStep(2);

  };


  return (
    <section id="user-register" className="step1_wrapper">
      <Form_Header step={1} totalSteps={totalSteps} />

      <div className="container">
        <Form className="auth_form" onSubmit={handleSubmit(onSubmit)}>
          <div className="row">

            {/* First Name */}
            <div className="col-lg-6 mb-4">
              <Form.Group>
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter First Name"
                  isInvalid={!!errors.first_name}
                  {...register("first_name", {
                    required: "First name is required",
                    minLength: {
                      value: 3,
                      message: "First Name must be at least 3 characters",
                    },
                    maxLength: {
                      value: 50,
                      message: "First Name cannot exceed 50 characters",
                    },
                    pattern: {
                      value: /^[A-Za-z\s]+$/,
                      message: "First Name can only contain letters and spaces",
                    },
                  })}
                />
                <div className="text-danger">
                  {errors.first_name?.message}
                </div>
              </Form.Group>
            </div>

            {/* Last Name */}
            <div className="col-lg-6 mb-4">
              <Form.Group>
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Last Name"
                  isInvalid={!!errors.last_name}
                  {...register("last_name", {
                    required: "Last name is required",
                    minLength: {
                      value: 3,
                      message: "Last Name must be at least 3 characters",
                    },
                    maxLength: {
                      value: 50,
                      message: "Last Name cannot exceed 50 characters",
                    },
                    pattern: {
                      value: /^[A-Za-z\s]+$/,
                      message: "Last Name can only contain letters and spaces",
                    },
                  })}
                />
                <div className="text-danger">
                  {errors.last_name?.message}
                </div>
              </Form.Group>
            </div>

            {/* Date of Birth */}
            <div className="col-lg-6 mb-4">
              <Form.Group>
                <Form.Label>Date of Birth</Form.Label>
                <Form.Control
                  type="date"
                  max={new Date().toISOString().split("T")[0]}
                  isInvalid={!!errors.date_of_birth}
                  {...register("date_of_birth", {
                    required: "Date of birth is required",
                    validate: {
                      notFuture: (value) => {
                        const today = new Date();
                        const dob = new Date(value);
                        return dob < today || "Date of birth cannot be a future date";
                      },
                      minAge: (value) => {
                        const today = new Date();
                        const dob = new Date(value);
                        const age = today.getFullYear() - dob.getFullYear();
                        const monthDiff = today.getMonth() - dob.getMonth();
                        const actualAge =
                          monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())
                            ? age - 1
                            : age;
                        return actualAge >= 14 || "You must be at least 14 years old";
                      },
                      maxAge: (value) => {
                        const today = new Date();
                        const dob = new Date(value);
                        const age = today.getFullYear() - dob.getFullYear();
                        return age <= 100 || "Please enter a valid date of birth";
                      },
                    },
                  })}
                />
                <div className="text-danger">
                  {errors.date_of_birth?.message}
                </div>
              </Form.Group>
            </div>

            {/* Mobile Number */}
            <div className="col-lg-6 mb-4">
              <Form.Group>
                <Form.Label>Contact Number</Form.Label>
                <Form.Control
                  isInvalid={!!errors.mobile_number}
                  placeholder="Contact Number"
                  type="text"
                  name="mobile_number"
                  maxLength={10}
                  {...register("mobile_number", {
                    required: "Contact Number is required",
                    pattern: {
                      value: /^[0-9]+$/,
                      message: "Only digits are allowed",
                    },
                    minLength: {
                      value: 10,
                      message: "Contact must be exactly 10 digits",
                    },
                    maxLength: {
                      value: 10,
                      message: "Contact must be exactly 10 digits",
                    },
                  })}
                />
                <div className="text-danger">
                  {errors.mobile_number?.message}
                </div>
              </Form.Group>
            </div>

            {/* Email */}
            <div className="col-12 mb-4">
              <Form.Group>
                <Form.Label>Enter Email Address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter Email"
                  isInvalid={!!errors.email}
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value: /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/,
                      message: "Enter a valid email address",
                    },
                  })}
                />
                <div className="text-danger">
                  {errors.email?.message}
                </div>
              </Form.Group>
            </div>

            <div className="col-12 mb-4">
              <Form.Group>
                <Form.Label>State</Form.Label>
                <Form.Select
                  isInvalid={!!errors.state_id}
                  disabled={statesLoading}
                  {...register("state_id", {
                    required: "Please select your state",
                  })}
                >
                  <option value="">
                    {statesLoading ? "Loading states..." : "Select State"}
                  </option>
                  {stateOptions.map((state) => (
                    <option key={state.id} value={state.id}>
                      {state.name}
                    </option>
                  ))}
                </Form.Select>
                <div className="text-danger">
                  {errors.state_id?.message}
                </div>
              </Form.Group>
            </div>

            {/* Address */}
            <div className="col-12 mb-4">
              <Form.Group>
                <Form.Label>Address</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  placeholder="Enter Address"
                  isInvalid={!!errors.address}
                  {...register("address", {
                    required: "Address is required",
                  })}
                />
                <div className="text-danger">
                  {errors.address?.message}
                </div>
              </Form.Group>
            </div>

            {/* Password */}
            <div className="col-lg-6 mb-4">
              <Form.Group>
                <Form.Label>Password</Form.Label>
                <div className="password_field_holder">
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    isInvalid={!!errors.password}
                    {...register("password", {
                      required: "Password is required",
                      minLength: { value: 8, message: "Minimum 8 characters" },
                    })}
                  />

                  <div
                    className="eye_icons_holder"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{ cursor: "pointer" }}
                  >
                    <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} />
                  </div>
                </div>
                <div className="text-danger">
                  {errors.password?.message}
                </div>
              </Form.Group>
            </div>

            {/* Re-Enter Password */}
            <div className="col-lg-6 mb-5">
              <Form.Group>
                <Form.Label>Re-Enter Password</Form.Label>

                <div className="password_field_holder">
                  <Form.Control
                    type={showConfirmPassword ? "text" : "password"}
                    placeholder="Confirm Password"
                    isInvalid={!!errors.re_password}
                    {...register("re_password", {
                      required: "Please confirm your password",
                      validate: (value) =>
                        value === password || "Passwords do not match",
                    })}
                  />

                  <div
                    className="eye_icons_holder"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    style={{ cursor: "pointer" }}
                  >
                    <FontAwesomeIcon icon={showConfirmPassword ? faEye : faEyeSlash} />
                  </div>
                </div>
                <div className="text-danger">
                  {errors.re_password?.message}
                </div>
              </Form.Group>
            </div>

            {/* Next Button */}
            <div className="form_btn_holder">
              <Common_Btn btnText={"Next"} type="submit" />
            </div>

          </div>
        </Form>
      </div>
    </section>
  );
};

export default Create_Account_step1;
